module.exports = __webpack_public_path__ + "static/messenger-65c16ea75d02b91ece1f4c45ddb39870.svg";